import { Component } from '@angular/core';

@Component({
  selector: 'app-data-protection',
  imports: [],
  templateUrl: './data-protection.component.html',
  styleUrl: './data-protection.component.sass'
})
export class DataProtectionComponent {

}
